import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction";
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import FullCalendar from "@fullcalendar/react";
import {useRef} from "react";
import {AttendanceStepEntity} from "../../../attendance/domain/entity/attendance-step.entity"; // a plugin!

export function FullBusinessCalendar(props: {
  steps: AttendanceStepEntity[],
  onStepClick: (stepId: AttendanceStepEntity) => any,
}) {
  const calendarRef = useRef<any>(null)
  
  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[ dayGridPlugin, interactionPlugin ]}
      initialView="dayGridMonth" // timeGridWeek dayGridMonth
      // dateClick={(evt) => alert(evt.date.toISOString())}
      height={800}
      locale={ptBrLocale}
      dayHeaderFormat={{
        weekday: 'long'
      }}
      headerToolbar={{
        start: '',
        center: 'title',
      }}
      eventClick={item => {
        props.onStepClick(props.steps.find(w => w.id === item.event.id) as AttendanceStepEntity)
      }}
      displayEventTime={false}
      events={props.steps.map(w => ({
        id: w.id,
        start: w.endDate,
        end: w.endDate,
        title: `${w.attendanceCode} - ${w.stepType.description} - ${w.clientName}`,
        color: w.stepType.color,
        allDay: false,
        overlap: false,
      }))}
    />
  )
}